import type { IFieldConfig } from "../interface/form.interfaces";
import type { TFieldValue, TFormErrors, TFormValues } from "../types/form.types";

export function validateField(
    field: IFieldConfig,
    value: TFieldValue,
    allValues: TFormValues
): string | null {
    if (field.required) {
        const isEmpty =
            value === "" ||
            value === null ||
            value === undefined ||
            (field.type === "checkbox" && value === false);
        if (isEmpty) return `${field.label} is required`;
    }

    // No further validation if the field is empty and not required
    if (value === "" || value == null) return null;

    const v = field.validation;
    if (!v) return null;

    if (v.minLength && typeof value === "string" && value.length < v.minLength.value)
        return v.minLength.message;

    if (v.maxLength && typeof value === "string" && value.length > v.maxLength.value)
        return v.maxLength.message;

    if (v.min && typeof value === "number" && value < v.min.value)
        return v.min.message;

    if (v.max && typeof value === "number" && value > v.max.value)
        return v.max.message;

    if (v.pattern && typeof value === "string" && !v.pattern.value.test(value))
        return v.pattern.message;

    if (v.custom) return v.custom(value, allValues);

    return null;
}

export function validateAll(fields: IFieldConfig[], values: TFormValues): TFormErrors {
    return fields.reduce<TFormErrors>((acc, field) => {
        const error = validateField(field, values[field.name], values);
        if (error) acc[field.name] = error;
        return acc;
    }, {});
}

export function getDefaultValues(fields: IFieldConfig[]): TFormValues {
    return Object.fromEntries(
        fields.map((f) => [
            f.name,
            f.defaultValue ?? (f.type === "checkbox" ? false : ""),
        ])
    );
}